import { Box, Divider, Grid, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import React, { Fragment } from "react";
import { UNIT_LIST_CONVERT } from "src/constant";
import appConfig from "src/config/env";
import convertCurrency from "src/helper/convertCurrency";

const DetailField = ({ label, value }) => (
  <Typography
    variant="body2"
    sx={{ overflowWrap: "anywhere" }}
  >
    <strong>{label}: </strong>
    {value ?? "-"}
  </Typography>
);

const getImageUrl = (image) => {
  const src = typeof image === "string" ? image : image?.src;
  if (!src) return null;
  return src.startsWith("http") ? src : `${appConfig.API_FILE}/${src}`;
};

const formatPrice = (price) => (price === null || price === undefined || price === "" ? "-" : `${Number(price).toLocaleString("vi-VN")} đ`);

export default function ProductDetailView({ item }) {
  const imageUrl = getImageUrl(item?.image);

  return (
    <Grid
      container
      sx={{ width: "100%", p: "12px" }}
      spacing={2}
    >
      <Grid
        item
        xs={12}
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
          sm={3}
        >
          <Box
            role="img"
            aria-label={item?.name || "Ảnh sản phẩm"}
            sx={{
              width: "100%",
              background: imageUrl ? `url(${imageUrl}) center / contain no-repeat` : grey[100],
              pb: "100%",
            }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={9}
          container
          spacing={1}
          alignContent="flex-start"
        >
          <Grid
            item
            xs={12}
          >
            <DetailField
              label="Tên sản phẩm"
              value={item?.name}
            />
          </Grid>
          <Grid
            item
            xs={12}
          >
            <DetailField
              label="Tên tiếng Việt"
              value={item?.nameVi}
            />
          </Grid>
          <Grid
            item
            xs={12}
          >
            <DetailField
              label="Tên viết tắt"
              value={item?.shortName}
            />
          </Grid>
          <Grid
            item
            xs={12}
          >
            <DetailField
              label="Mã sản phẩm"
              value={item?.code}
            />
          </Grid>
          <Grid
            item
            xs={12}
          >
            <DetailField
              label="Đơn vị tính"
              value={UNIT_LIST_CONVERT[item?.unit] ?? item?.unit}
            />
          </Grid>
          <Grid
            item
            xs={12}
          >
            <DetailField
              label="VAT"
              value={item?.vat != null && item?.vat !== "" ? `${item.vat}%` : "-"}
            />
          </Grid>
          <Grid
            item
            xs={12}
          >
            <DetailField
              label="Số phiếu công bố"
              value={item?.notificationNo}
            />
          </Grid>
          <Grid
            item
            xs={12}
          >
            <DetailField
              label="Thương hiệu"
              value={item?.brand?.name ?? item?.brand}
            />
          </Grid>
          <Grid
            item
            xs={12}
          >
            <DetailField
              label="Nhà sản xuất"
              value={item?.manufacturer?.name ?? item?.manufacturer}
            />
          </Grid>
          <Grid
            item
            xs={12}
          >
            <DetailField
              label="Shelf life"
              value={item?.shelfLife}
            />
          </Grid>
          <Grid
            item
            xs={12}
          >
            <DetailField
              label="Mô tả kỹ thuật"
              value={item?.description}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid
        item
        xs={12}
      >
        <Divider sx={{ borderColor: "var(--grey) !important" }} />
      </Grid>

      {Array.isArray(item?.productModels) && item.productModels.length > 0 ? (
        item.productModels.map((model, index) => {
          const modelImageUrl = getImageUrl(model?.image);
          const shippingInfo = model?.shippingInfo;
          return (
            <Fragment key={model?._id ?? model?.id ?? index}>
              <Grid
                item
                xs={12}
                container
                spacing={2}
              >
                <Grid
                  item
                  xs={12}
                  sm={3}
                >
                  <Box
                    role="img"
                    aria-label={model?.name || `Ảnh phân loại ${index + 1}`}
                    sx={{
                      width: "100%",
                      background: modelImageUrl ? `url(${modelImageUrl}) center / contain no-repeat` : grey[100],
                      pb: "100%",
                    }}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={9}
                  container
                  spacing={1}
                  alignContent="flex-start"
                >
                  <Grid
                    item
                    xs={12}
                  >
                    <DetailField
                      label="Phân loại"
                      value={model?.name}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                  >
                    <DetailField
                      label="Mã phân loại"
                      value={model?.code}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                  >
                    <DetailField
                      label="Mã vạch"
                      value={model?.barcode}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                  >
                    <DetailField
                      label="Mã SKU"
                      value={model?.sku}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                  >
                    <DetailField
                      label="Giá"
                      value={formatPrice(model?.price)}
                    />
                    <Typography
                      variant="caption"
                      fontWeight={700}
                      fontStyle="italic"
                    >
                      ({convertCurrency(model?.price)} đồng)
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                  >
                    <DetailField
                      label="VAT"
                      value={model?.vat != null && model?.vat !== "" ? `${model.vat}%` : "-"}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                  >
                    <DetailField
                      label="Cân nặng sau đóng gói"
                      value={shippingInfo?.weight != null && shippingInfo?.weight !== "" ? `${shippingInfo.weight} g` : "-"}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                  >
                    <DetailField
                      label="Kích thước đóng gói (dài × rộng × cao)"
                      value={
                        [shippingInfo?.length, shippingInfo?.width, shippingInfo?.height].some((value) => value != null && value !== "")
                          ? `${shippingInfo?.length ?? "-"} × ${shippingInfo?.width ?? "-"} × ${shippingInfo?.height ?? "-"} cm`
                          : "-"
                      }
                    />
                  </Grid>
                </Grid>
              </Grid>
              {index < item.productModels.length - 1 && (
                <Grid
                  item
                  xs={12}
                >
                  <Divider sx={{ borderColor: "var(--grey) !important" }} />
                </Grid>
              )}
            </Fragment>
          );
        })
      ) : (
        <Grid
          item
          xs={12}
        >
          <Typography>Sản phẩm chưa có phân loại</Typography>
        </Grid>
      )}
    </Grid>
  );
}
